import React from "react";
import { useTranslation } from "react-i18next";
import { getStatusMeta } from "./constants";

const SIZES = {
  xs: "px-1.5 py-0.5 text-[10px]",
  sm: "px-2 py-0.5 text-[11px]",
  md: "px-2.5 py-1 text-xs",
};

const WearableStatusBadge = ({ status, size = "sm", className = "" }) => {
  // Subscribe to language changes so the translated label re-renders.
  useTranslation();
  const meta = getStatusMeta(status);
  return (
    <span
      className={`inline-flex items-center rounded font-medium ${
        SIZES[size] || SIZES.sm
      } ${className}`}
      style={{ backgroundColor: meta.bg, color: meta.color }}
    >
      {meta.label}
    </span>
  );
};

export default WearableStatusBadge;
